import React from "react";

export interface CellContextProps {
    row?: any;
    key?: symbol;
}

export const CellContext = React.createContext<CellContextProps>({});
